<template>
    <span class="d-flex flex-column" v-if="value">
        <span>{{ value }}</span>
        <b-link v-if="extraValue" :to="{ name: 'requestsDetail', params: { id: extraValue['id'] } }">Заявка №{{extraValue.id}}</b-link>
    </span>
    <span v-else>
        &mdash;
    </span>
</template>

<script>
    export default {
        name: "AnimalLastCatchingCell",
        props: {
            value: {},
            extraValue: {}
        }
    }
</script>

<style scoped>

</style>